import datasetConfigs from "./datasets";

const datasetViewConfig = datasetConfigs;

export default datasetViewConfig;
